import { AccountDetails } from '@/components/NeolexonIcon/Icons/AccountDetails';
import { Book } from '@/components/NeolexonIcon/Icons/Book';
import { BookShelf } from '@/components/NeolexonIcon/Icons/BookShelf';
import { ChevronLeft } from '@/components/NeolexonIcon/Icons/ChevronLeft';
import { ChevronRight } from '@/components/NeolexonIcon/Icons/ChevronRight';
import { Ellipsis } from '@/components/NeolexonIcon/Icons/Ellipsis';
import { ExerciseMaterial } from '@/components/NeolexonIcon/Icons/ExerciseMaterial';
import { Filter } from '@/components/NeolexonIcon/Icons/Filter';
import { FlowersCard } from '@/components/NeolexonIcon/Icons/FlowersCard';
import { Grid } from '@/components/NeolexonIcon/Icons/Grid';
import { HelpCircle } from '@/components/NeolexonIcon/Icons/HelpCircle';
import { Letter } from '@/components/NeolexonIcon/Icons/Letter';
import { Link } from '@/components/NeolexonIcon/Icons/Link';
import { Lugnut } from '@/components/NeolexonIcon/Icons/Lugnut';
import { MagnifyingGlass } from '@/components/NeolexonIcon/Icons/MagnifyingGlass';
import { Sentence } from '@/components/NeolexonIcon/Icons/Sentence';
import { UnorderedList } from '@/components/NeolexonIcon/Icons/UnorderedList';
import { WeightEasy } from '@/components/NeolexonIcon/Icons/WeightEasy';
import { WeightHard } from '@/components/NeolexonIcon/Icons/WeightHard';
import { WeightMedium } from '@/components/NeolexonIcon/Icons/WeightMedium';

import { IconName } from '@/components/NeolexonIcon/Icons/types';

export const iconMap = {
  accountDetails: AccountDetails,
  book: Book,
  bookShelf: BookShelf,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  ellipsis: Ellipsis,
  exerciseMaterial: ExerciseMaterial,
  filter: Filter,
  flowersCard: FlowersCard,
  grid: Grid,
  helpCircle: HelpCircle,
  letter: Letter,
  link: Link,
  lugnut: Lugnut,
  magnifyingGlass: MagnifyingGlass,
  sentence: Sentence,
  unorderedList: UnorderedList,
  weightEasy: WeightEasy,
  weightHard: WeightHard,
  weightMedium: WeightMedium,
} as const;

export const isNeolexonIcon = (name: unknown): name is IconName =>
  typeof name === 'string' && name in iconMap;
